<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="transfer-request"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
          <!-- Kolom tanggal (jika nanti kamu tambahkan ke columns) -->
          <template slot="item.created_at" slot-scope="{ item }">
            <div v-if="item.created_at != null">
              {{ $moment(item.created_at).format("DD/MM/YYYY") }}
            </div>
            <div v-else>-</div>
          </template>

          <template slot="item.verified_at" slot-scope="{ item }">
            <div v-if="item.verified_at != null">
              {{ $moment(item.verified_at).format("DD/MM/YYYY") }}
            </div>
            <div v-else>-</div>
          </template>

          <template slot="item.sales_item_ids" slot-scope="{ item }">
            <div v-if="item.sales_item_ids.length > 0">
              <ul>
                <br />
                <li v-for="(salesItem, index) in item.sales_items" :key="index">
                  {{ salesItem.package.name }}
                </li>
              </ul>
            </div>
            <div v-else>-</div>
          </template>

          

          <!-- Kolom status: chip warna -->
          <template slot="item.status" slot-scope="{ item }">
            <v-chip
              :color="item.status === 'verified' ? 'green' : (item.status === 'unverified' ? 'red' : 'blue')"
              text-color="white"
              small
            >
              {{ item.status.charAt(0).toUpperCase() + item.status.slice(1) }}
            </v-chip>
          </template>

          <!-- Slot aksi di awal cell action: sisipkan “penanda” -->
          <template slot="item.action" slot-scope="{ item }">
            <!-- Jika ingin tetap tampil VIEW kustom-mu sendiri, letakkan di atas penanda
            <v-btn small rounded depressed color="success" dark class="mr-2" @click="onClickView(item)">VIEW</v-btn>
            -->
            <span
              v-if="item?.status === 'verified' && !hasVerification"
              class="action-hide-guard"
            />
          </template>
        </datatable>
      </div>
    </div>

    <form-action ref="form" module="transfer-request" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="transfer-request"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormAction from "./Form";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Member", route: "" },
      { title: "Transfer Paket Member" }
    ]);
  },
  data() {
    return {
      title: "Transfer Paket Member",
      url: "transfer-request/data",
      columns: [
        { value: "id" },
        {
          text: "Dibuat Tanggal",
          value: "created_at",
          sortable: true,
          searchable: false
        },
        {
          text: "Dari Member",
          value: "from_member_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Ke Member",
          value: "to_member_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Paket yang Dipindahkan",
          value: "sales_item_ids",
          sortable: false,
          searchable: false
        },
        {
          text: "Status",
          value: "status",
          sortable: true,
          searchable: true
        },
        {
          text: "Tanggal Verifikasi",
          value: "verified_at",
          sortable: true,
          searchable: true
        }
        // Jika kamu mau tampilkan created_at, tambahkan ini ke columns:
        // { text: "Dibuat", value: "created_at", sortable: true, searchable: false }
      ]
    };
  },
  computed: {
    // Permission verifier untuk modul ini
    hasVerification() {
      return this.$store.getters.hasPermission("transfer-request", "verification");
    }
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      // Guard tambahan kalau ada akses langsung
      if (item?.status === "verified" && !this.hasVerification) {
        this.$swal.fire({
          icon: "info",
          title: "Tidak Diizinkan",
          text: "Data yang sudah diverifikasi tidak dapat diubah/dihapus oleh akun Anda.",
          showConfirmButton: true
        });
        return;
      }
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    }
  },
  components: {
    Datatable,
    DeleteDialog,
    FormAction
  }
};
</script>

<style scoped>
/* Sembunyikan seluruh konten aksi bawaan (menu/tombol) setelah penanda */
::v-deep td .action-hide-guard ~ * {
  display: none !important;
}
</style>
